// Stairs library

export const STAIRS_LIBRARY = [
  { id: 'stairs-straight', name: 'Straight Stairs', width: 36, height: 120, steps: 12, icon: '🪜', type: 'straight' },
  { id: 'stairs-l', name: 'L-Shaped Stairs', width: 80, height: 80, steps: 12, icon: '🪜', type: 'l-shape' },
  { id: 'stairs-u', name: 'U-Shaped Stairs', width: 80, height: 120, steps: 16, icon: '🪜', type: 'u-shape' },
  { id: 'stairs-spiral', name: 'Spiral Stairs', width: 60, height: 60, steps: 12, icon: '🌀', type: 'spiral' },
  { id: 'ramp-straight', name: 'Straight Ramp', width: 48, height: 144, icon: '📐', type: 'ramp' },
  { id: 'ramp-switchback', name: 'Switchback Ramp', width: 96, height: 144, icon: '📐', type: 'ramp-switchback' },
];
